"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Typography,
  Container,
  IconButton,
  InputAdornment,
  Box,
  Autocomplete,
  Tabs,
  Tab,
  Card,
  CardContent,
  Grid,
  Divider,
  Paper,
  Alert,
} from "@mui/material"
import {
  Visibility,
  VisibilityOff,
  Add as AddIcon,
  List as ListIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Badge as BadgeIcon,
  VpnKey as VpnKeyIcon,
  SupervisorAccount as SupervisorAccountIcon,
} from "@mui/icons-material"
import TablaUsuariosComponent from "./TablaUsuariosComponent"
import UserForm from "./UserForm"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

const GestionUsuarioComponent = () => {
  const { postUsuario, isNavbarCollapsed } = useContext(ErpContext)

  const [tabValue, setTabValue] = useState(0)
  const [showSuccess, setShowSuccess] = useState(false)

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  // no-op

  const ErrorModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error",
      text: "Error al crear el usuario",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  const SucessModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "success",
      text: "Usuario creado correctamente",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Paper elevation={0} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#f8f9fa" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                color: "#5b5b5f",
                fontWeight: 600,
                textTransform: "none",
                fontSize: "16px",
                minHeight: "60px",
                "&.Mui-selected": {
                  color: "#5b5b5f",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#5b5b5f",
                height: 3,
              },
            }}
          >
            <Tab icon={<AddIcon />} label="Crear Usuario" iconPosition="start" sx={{ mr: 2 }} />
            <Tab icon={<ListIcon />} label="Gestionar Usuarios" iconPosition="start" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <Card elevation={2} sx={{ borderRadius: 2 }}>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <SupervisorAccountIcon sx={{ color: "#5b5b5f", mr: 2, fontSize: 28 }} />
                <Typography variant="h5" sx={{ color: "#5b5b5f", fontWeight: 600 }}>
                  Nuevo Usuario
                </Typography>
              </Box>

              {showSuccess && (
                <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
                  ¡Usuario creado exitosamente!
                </Alert>
              )}

              <UserForm
                mode="create"
                formId="create-user-form"
                initialValues={{}}
                onSubmit={async (payload) => {
                  const res = await postUsuario(
                    payload.usuario,
                    payload.nombre,
                    payload.apellido,
                    payload.telefono,
                    payload.email,
                    payload.direccion,
                    payload.localidad,
                    payload.provincia,
                    payload.password,
                    payload.rol,
                    payload.dniCuitCuil,
                  )
                  if (!res || res.success !== true) throw new Error("Error al crear usuario")
                }}
                onSuccess={() => {
                  setShowSuccess(true)
                  setTimeout(() => setShowSuccess(false), 3000)
                  SucessModal()
                }}
                onError={() => {
                  ErrorModal()
                }}
                renderActions={({ resetForm, submitting }) => (
                  <>
                    <Button
                      variant="outlined"
                      onClick={resetForm}
                      sx={{
                        borderColor: "#5b5b5f",
                        color: "#5b5b5f",
                        "&:hover": {
                          borderColor: "#5b5b5f",
                          backgroundColor: "rgba(91, 91, 95, 0.04)",
                        },
                      }}
                    >
                      Limpiar
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      startIcon={<AddIcon />}
                      disabled={submitting}
                      sx={{
                        backgroundColor: "#5b5b5f",
                        "&:hover": { backgroundColor: "#4a4a4e" },
                        px: 4,
                      }}
                    >
                      Crear Usuario
                    </Button>
                  </>
                )}
              />
            </CardContent>
          </Card>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <TablaUsuariosComponent />
        </TabPanel>
      </Paper>
    </Container>
  )
}

export default GestionUsuarioComponent
